import { atom, useAtom } from 'jotai';
import React from 'react';

interface ModalOptions {
  showCloseButton: boolean;
}

interface ModalAtom {
  options: ModalOptions;
  content: JSX.Element | null;
}

export const modalAtom = atom<ModalAtom | null>(null);

const defaultOptions: ModalOptions = {
  showCloseButton: true,
};

export function useModal() {
  const [modal, setModal] = useAtom(modalAtom);

  const openModal = React.useCallback(
    (content: JSX.Element, options: Partial<ModalOptions> = {}) => {
      setModal({
        content,
        options: { ...defaultOptions, ...options },
      });
    },
    [setModal]
  );

  const closeModal = React.useCallback(() => {
    setModal(null);
  }, [setModal]);

  return {
    modal,
    openModal,
    closeModal,
  };
}
